module.exports = __webpack_public_path__ + "img/displacement-VARILUX-COMFORT.9b05febd.png";